import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: DashboardLayout,
    children: [
      {
        path: process.env.VUE_APP_VERSION,
        redirect: 'home',
        component: {
          render(c) { return c('router-view') }
        },
        children: [
          {
            path: 'home',
            alias: '/home',
            name: 'home',
            component: () => import(/* webpackChunkName: "demo" */ '../views/Home/Home.vue'),
            meta: {
              permission: [],
              requiresAuth: true
            }
          },
          {
            path: 'claimwizard',
            name: 'claimwizard',
            component: () => import(/* webpackChunkName: "demo" */ '../views/ClaimWizard/ClaimWizard.vue')
          },
          {
            path: 'usermanagement',
            name: 'usermanagement',
            component: () => import(/* webpackChunkName: "demo" */ '../views/UserManagement/UserManagement.vue')
          },
          {
            path: 'reviewpage',
            name: 'reviewpage',
            component: () => import(/* webpackChunkName: "demo" */ '../views/ReviewPage/ReviewPage.vue'),
            props: true 
          },
          {
            path: 'reviewWorkflowPage',
            name: 'reviewWorkflowPage',
            component: () => import(/* webpackChunkName: "demo" */ '../views/ReviewWorkflowPage/ReviewWorkflowPage.vue'),
            props: true 
          },
          {
            path: 'dashboard',
            name: 'dashboard',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
          },
          {
            path: 'icons',
            name: 'icons',
            component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
          },
          {
            path: 'profile',
            name: 'profile',
            component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue')
          },
          {
            path: 'maps',
            name: 'maps',
            component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue')
          },
          {
            path: 'tables',
            name: 'tables',
            component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/forgetpassword',
        name: 'forgetpassword',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Auth/ForgetPassword.vue')
      },
      {
        path: '/resetpassword',
        name: 'resetpassword',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Auth/ResetPassword.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', name: 'notfound', component: NotFound }
    ]
  }
];

export default routes;
